import { PREMIUM_FEATURES } from "@common/flatRateBilling";
import { useAllowFeature } from "./useAllowFeature";
import { useTypedFlags } from "./useTypedFlags";

export function useCanUseFixedAssets(): boolean {
    const { fixedAssets: isFixedAssetsFlagEnabled } = useTypedFlags();
    const { hasAccess: hasFixedAssetsPlan } = useAllowFeature(
        PREMIUM_FEATURES.FIXED_ASSETS,
    );

    return isFixedAssetsFlagEnabled && hasFixedAssetsPlan;
}
